import React, { useRef, useState } from 'react'
import checked_red from "../../assets/images/icons/checked_24px_red.svg"
import closed_red from "../../assets/images/icons/icon_close_24px.svg"
import { PrimaryButton, SecondaryButton2th } from './../../components/StyledButtons';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectLanguage } from '../../redux/language/selector';
import { LinkWhiteHoverOrange } from './../../components/StyledComponents';
import ModalPricingOnPremise from './ModalPricingOnPremise';
import ModalContactDiscussionForm from '../../components/ModalContactDiscussionForm';

const PricingOnPremiseComparison = () => {
    const { t } = useTranslation()

    const language = useSelector(selectLanguage)

    const [modalDiscussionOpen, setModalDiscussionOpen] = useState(false);
    const [modalOnPremiseOpen, setModalOnPremiseOpen] = useState(false)

    const modalDiscussionRef = useRef(null);
    const modalOnPremiseRef = useRef(null)

    const handleOverlayClick = (event) => {
        if (modalDiscussionRef.current && !modalDiscussionRef.current.contains(event.target)) {
            setModalDiscussionOpen(false)
        }
        if (modalOnPremiseRef.current && !modalOnPremiseRef.current.contains(event.target)) {
            setModalOnPremiseOpen(false)
        }

    };

    document.onkeydown = function (evt) {
        if (evt.code === 'Escape') {
            setModalDiscussionOpen(false)
            setModalOnPremiseOpen(false)

        }
    };

    return (
        <>
            {language === "en"
                ?
                <div className='pricing_cloud-plans__comparison container pt-50' id="targetSection">
                    <p className='font-48 text-white text-center'>Premise Plans Feature <span className='title'>Comparison</span></p>
                    <div className='row table pt-50'>
                        <div className='table-header'>
                            <div className="hidden xl-block col-xl-6">
                                <div>
                                    <p className='text-left'>Features</p>
                                </div>
                            </div>
                            <div className="col-xs-4 col-xl-2 border-right">
                                <p>Trial</p>
                            </div>
                            <div className="col-xs-4 col-xl-2 border-right">
                                <p>PRO</p>
                            </div>
                            <div className="col-xs-4 col-xl-2">
                                <p>Enterprise</p>
                            </div>

                        </div>
                        <div className='table-body'>
                            <div className='col-sm-12'>
                                <div className="row">
                                    <div className="col-sm-12 col-xl-6 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Generator API Rate Limit</p>
                                            <p className='text-left table-sub-title pt-5'>An API call is made each time a secure code is generated, revoked or updated. The maximum number of API calls per day</p>
                                        </div>
                                    </div>

                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-22">
                                            <p>1000/day</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-22">
                                            <p>1000/day</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-22">
                                            <p>As Per Need</p>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-sm-12 col-xl-6 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Max Size Per EDC Code</p>
                                            <p className='text-left table-sub-title pt-5'>This is the maximum size of all data and attached files for a secure EDC code.</p>
                                        </div>
                                    </div>

                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <p>25MB</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <p>No Limit</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <p>No Limit</p>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-sm-12'>
                                <div className="row">
                                    <div className="col-sm-12 col-xl-6 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Web Validator</p>
                                            <p className='text-left table-sub-title pt-5'>Validate secure codes using just the browser and your domain. <LinkWhiteHoverOrange href="https://validation.qrypto.ee" target='_blank'>See here for an example.</LinkWhiteHoverOrange></p>
                                        </div>
                                    </div>

                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-sm-12'>
                                <div className="row">
                                    <div className="col-sm-12 col-xl-6 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>AWS S3/Azure/GCS Support</p>
                                            <p className='text-left table-sub-title pt-5'>Support for data to be stored on cloud service or network attached storage in addition to the default of local storage</p>
                                        </div>
                                    </div>

                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-22">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-22">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-22">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-6 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Web Validator Customization</p>
                                            <p className='text-left table-sub-title pt-5'>Customization of the Web validation page</p>
                                        </div>
                                    </div>

                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <p>Only logo</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-sm-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-6 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>EDC Updates</p>
                                            <p className='text-left table-sub-title pt-5'>Update the data and attachments for previously generated secure EDC codes</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-6 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Support</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <p>Business Hours</p>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <p>Business Hours</p>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <p>24x7</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-sm-12'>
                                <div className="row">
                                    <div className="col-sm-12 col-xl-6 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>QR - URL Option</p>
                                            <p className='text-left table-sub-title pt-5'>This makes the Secure QR content a URL enabling use of generic QR code scanners. This can have security implications - please get in touch for guidance.</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-22">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-22">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-22">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-6 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Primary Data Code (PDC)</p>
                                            <p className='text-left table-sub-title pt-5'>Create self-contained Text only QR Codes for offline validation. See <LinkWhiteHoverOrange href="/technology/overview">PDC vs EDC</LinkWhiteHoverOrange></p>
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-6 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Multi Code Generation Per API</p>
                                            <p className='text-left table-sub-title pt-5'>Support for generating multiple secure QR codes per API call</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={closed_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={closed_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-6 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Files API</p>
                                            <p className='text-left table-sub-title pt-5'>Files API: Generate Secure QR codes by providing data and instructions via files</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={closed_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={closed_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-sm-12'>
                                <div className="row">
                                    <div className="col-sm-12 col-xl-6 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Pre/Post Processing</p>
                                            <p className='text-left table-sub-title pt-5'>Support for scripts to preprocces data before the Files API process the input files to generate Secure QR and support for post processing of the generated Secure QR data.</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-22">
                                            <img src={closed_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-22">
                                            <img src={closed_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-22">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-6 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Archiving</p>
                                            <p className='text-left table-sub-title pt-5'>Support for archiving of Files API requests</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={closed_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={closed_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-sm-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-6 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Multiple Instances</p>
                                            <p className='text-left table-sub-title pt-5'>Flexible deployment option for both Validation and Generation</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={closed_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={closed_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-6 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>TLS Authentication</p>
                                            <p className='text-left table-sub-title pt-5'>Support for TLS client authentication by API Gateways</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={closed_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={closed_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body' style={{ borderBottom: "none" }}>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-6 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>HSM Integration</p>
                                            <p className='text-left table-sub-title pt-5'>Integration with your Hardware Security Module</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={closed_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={closed_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-footer'>
                            <div className="hidden xl-block col-xl-6">
                            </div>

                            <div className="col-xs-4 col-xl-2">
                                <SecondaryButton2th
                                
                                >Get Started</SecondaryButton2th>
                            </div>
                            <div className="col-xs-4 col-xl-2">
                                <PrimaryButton style={{ padding: "0 10px" }}
                                onClick={() => setModalOnPremiseOpen(true)}
                                >Schedule Demo</PrimaryButton>
                            </div>
                            <div className="col-xs-4 col-xl-2">
                                <PrimaryButton
                                onClick={() => setModalDiscussionOpen(true)}
                                >Contact Us</PrimaryButton>
                            </div>
                            <div className='col-xs-12 pt-20'>
                                <p className='font-weight-medium'><span className='font-weight-semi-bold'>Note:</span> Requirements: x86-64 Linux physical or virtual machine or cloud instance with at-least 512MB RAM and 8GB disk</p>
                                <p className='italic text-gray'>All prices are in USD</p>
                            </div>
                        </div>
                    </div>
                </div>
                :
                <div className='pricing_cloud-plans__comparison container pt-50' id="targetSection">
                    <p className='font-48 text-white text-center'><span className='title'>So sánh </span>tính năng lưu trữ tại chỗ</p>
                    <div className='row table pt-50'>
                        <div className='table-header'>
                            <div className="hidden xl-block col-xl-6">
                                <div>
                                    <p className='text-left'>Tính năng</p>
                                </div>
                            </div>
                            <div className="col-xs-4 col-xl-2 border-right">
                                <p>Dùng thử</p>
                            </div>
                            <div className="col-xs-4 col-xl-2 border-right">
                                <p>Chuyên nghiệp</p>
                            </div>
                            <div className="col-xs-4 col-xl-2">
                                <p>Doanh nghiệp</p>
                            </div>

                        </div>
                        <div className='table-body'>
                            <div className='col-sm-12'>
                                <div className="row">
                                    <div className="col-sm-12 col-xl-6 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Giới hạn tốc độ API của trình tạo</p>
                                            <p className='text-left table-sub-title pt-5'>Lệnh gọi API được thực hiện mỗi khi mã bảo mật được tạo, thu hồi hoặc cập nhật. Số lượng lệnh gọi API tối đa mỗi ngày</p>
                                        </div>
                                    </div>

                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-22">
                                            <p>1000/ngày</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-22">
                                            <p>1000/ngày</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-22">
                                            <p>Theo nhu cầu</p>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-sm-12 col-xl-6 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Kích thước tối đa cho mỗi mã EDC</p>
                                            <p className='text-left table-sub-title pt-5'>Đây là kích thước tối đa của tất cả dữ liệu và tệp đính kèm để có mã EDC an toàn.</p>
                                        </div>
                                    </div>

                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <p>25MB</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <p>Không giới hạn</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <p>Không giới hạn</p>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-sm-12'>
                                <div className="row">
                                    <div className="col-sm-12 col-xl-6 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Trình xác thực web</p>
                                            <p className='text-left table-sub-title pt-5'>Xác thực mã bảo mật chỉ bằng trình duyệt và miền của bạn. <LinkWhiteHoverOrange href="https://validation.qrypto.ee" target='_blank'>Xem ở đây để biết ví dụ.</LinkWhiteHoverOrange></p>
                                        </div>
                                    </div>

                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-sm-12'>
                                <div className="row">
                                    <div className="col-sm-12 col-xl-6 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Hỗ trợ AWS S3/Azure/GCS</p>
                                            <p className='text-left table-sub-title pt-5'>Hỗ trợ dữ liệu được lưu trữ trên dịch vụ đám mây hoặc bộ lưu trữ gắn mạng ngoài bộ nhớ cục bộ mặc định</p>
                                        </div>
                                    </div>

                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-22">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-22">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-22">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-6 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Tùy chỉnh trình xác thực web</p>
                                            <p className='text-left table-sub-title pt-5'>Tùy chỉnh trang xác thực Web</p>
                                        </div>
                                    </div>

                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <p>Chỉ hỗ trợ logo</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-sm-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-6 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Cập nhật EDC</p>
                                            <p className='text-left table-sub-title pt-5'>Cập nhật dữ liệu và tệp đính kèm cho mã EDC an toàn được tạo trước đó</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-6 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Hỗ trợ</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <p>Giờ hành chính</p>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <p>Giờ hành chính</p>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <p>24x7</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-sm-12'>
                                <div className="row">
                                    <div className="col-sm-12 col-xl-6 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Tùy chọn QR - URL</p>
                                            <p className='text-left table-sub-title pt-5'>Điều này làm cho nội dung QR bảo mật trở thành một URL cho phép sử dụng các máy quét mã QR chung. Điều này có thể có ý nghĩa bảo mật - vui lòng liên hệ để được hướng dẫn.</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-22">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-22">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-22">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-6 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Mã dữ liệu chính (PDC)</p>
                                            <p className='text-left table-sub-title pt-5'>Tạo Mã QR chỉ có văn bản độc lập để xác thực ngoại tuyến. Xem <LinkWhiteHoverOrange href="/technology/overview">PDC và EDC</LinkWhiteHoverOrange></p>
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-6 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Tạo nhiều mã cho mỗi API</p>
                                            <p className='text-left table-sub-title pt-5'>Hỗ trợ tạo nhiều mã QR an toàn cho mỗi lệnh gọi API</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={closed_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={closed_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-6 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Tệp API</p>
                                            <p className='text-left table-sub-title pt-5'>Tệp API: Tạo mã QR an toàn bằng cách cung cấp dữ liệu và hướng dẫn qua tệp</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={closed_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={closed_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-sm-12'>
                                <div className="row">
                                    <div className="col-sm-12 col-xl-6 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Xử lý trước/sau</p>
                                            <p className='text-left table-sub-title pt-5'>Hỗ trợ các tập lệnh xử lý trước dữ liệu trước khi API tệp xử lý các tệp đầu vào để tạo QR bảo mật và hỗ trợ xử lý hậu kỳ dữ liệu QR bảo mật đã tạo.</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-22">
                                            <img src={closed_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-22">
                                            <img src={closed_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-22">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-6 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Lưu trữ</p>
                                            <p className='text-left table-sub-title pt-5'>Hỗ trợ lưu trữ các yêu cầu tệp API</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={closed_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={closed_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-sm-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-6 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Nhiều trường hợp</p>
                                            <p className='text-left table-sub-title pt-5'>Tùy chọn triển khai linh hoạt cho cả Xác thực và Tạo</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={closed_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={closed_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-6 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Xác thực TLS</p>
                                            <p className='text-left table-sub-title pt-5'>Hỗ trợ xác thực ứng dụng khách TLS bằng API Gateways</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={closed_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={closed_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body' style={{ borderBottom: "none" }}>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-6 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Tích hợp HSM</p>
                                            <p className='text-left table-sub-title pt-5'>Tích hợp với Module bảo mật phần cứng của bạn</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={closed_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={closed_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-xl-2 pt-15-max1199">
                                        <div className="pt-xl-12">
                                            <img src={checked_red} alt="" className='checked_img' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-footer'>
                            <div className="hidden xl-block col-xl-6">
                            </div>
                            <div className="col-xs-4 col-xl-2">
                                <SecondaryButton2th>{t('button.get-started')}</SecondaryButton2th>
                            </div>
                            <div className="col-xs-4 col-xl-2">
                                <PrimaryButton style={{ padding: "0 10px" }}
                                onClick={() => setModalOnPremiseOpen(true)}
                                >{t('button.schedule-demo')}</PrimaryButton>
                            </div>
                            <div className="col-xs-4 col-xl-2">
                                <PrimaryButton style={{ padding: "0 5px" }}
                                onClick={() => setModalDiscussionOpen(true)}
                                >{t('button.contact-us')}</PrimaryButton>
                            </div>
                            <div className='col-xs-12 pt-20'>
                                <p className='font-weight-medium'><span className='font-weight-semi-bold'>Lưu ý:</span> Yêu cầu: x86-64 Linux vật lý hoặc máy ảo hoặc phiên bản đám mây có RAM tối thiểu 512MB và ổ đĩa 8GB</p>
                                <p className='italic text-gray'>Tất cả giá đều tính bằng USD</p>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {modalDiscussionOpen && <ModalContactDiscussionForm
                setOpenModal={setModalDiscussionOpen}
                handleOverlayClick={handleOverlayClick}
                modalRef={modalDiscussionRef} />}
            {modalOnPremiseOpen && <ModalPricingOnPremise
                setOpenModal={setModalOnPremiseOpen}
                handleOverlayClick={handleOverlayClick}
                modalRef={modalOnPremiseRef} />}
        </>
    )
}

export default PricingOnPremiseComparison